"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.description.placeholder': 'Inserisci descrizione del progetto',
};
